import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom';
import AuthContextProvider from './context/AuthContext';
import { Provider } from 'react-redux'
import {store,persistor } from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
<PersistGate loading={null} persistor={persistor}>
<ChakraProvider>
<BrowserRouter>
<AuthContextProvider>
  <App />
</AuthContextProvider>
</BrowserRouter>
  </ChakraProvider>
</PersistGate>
  </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
